import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames } from '@dt/fe-utils'
import { payPlanMobx } from '@mobxStore'

interface IProps {
  option: INoTipTipOption;
  onSelected?: () => void;
}

const NoTipTipItem: FC<IProps> = ({ option, onSelected }) => {
  const selected = payPlanMobx.selectedTipOption?.type === 'noTip'

  const onClick = () => {
    payPlanMobx.selectTipOption(option)
    onSelected && onSelected()
  }

  return (
    <li className={classNames('select-tip-item', { selected })} data-cypid='noTipTipItem' onClick={onClick}>
      <span className='amount'>{i18n.t('pay.noTip')}</span>
      <i className={classNames('iconfont', selected ? 'icon-checked' : 'icon-circle')} />
    </li>
  )
}

export default observer(NoTipTipItem)
